var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 15.33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.2 1.76-11.2 11.24a1.42 1.42 0 0 1 -2 0l-11.24-11.24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow-down-icon.48507d3a8eb83809b17c9730ac776db4.svg";